// @flow

import React, { type Node, useCallback } from 'react';

import { FieldCustomerDocument } from '../field-customer-document';
import { getCountry, useIncomingPayment } from '@tectonics/prs/incoming-payment';
import { getCountryFromCode } from '@tectonics/commons/country';
import { useTranslation } from 'react-i18next';

export function FieldGenericDocument(): Node {

  const incomingPayment = useIncomingPayment();
  const countryCode = getCountry(incomingPayment);
  const country = getCountryFromCode(countryCode);

  const customerForm = country?.customerForm;
  if (!customerForm) {
    throw new Error(`Error: No customer form found for country ${countryCode}`);
  }

  const { t } = useTranslation('opened-page');
  const { document } = customerForm;

  const formatRaw = useCallback((rawValue: string): string => {
    if (!document) {
      return rawValue;
    }

    return document.formatFunction(rawValue, document.mask);
  }, [document]);

  if (!document) {
    return null;
  }

  return (
    <FieldCustomerDocument
      inputData={{
        inputFieldName: document.inputFieldName,
        label: t(document.labelKey),
        specDocumentName: document.specDocumentName,
      }}
      mask={document.mask}
      normalizer={document.normalizer}
      formatRaw={formatRaw}
      validationErrorRenderer={document.validationError}
    />
  );
}
